import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { FindInPage } from '@material-ui/icons';
import { Redirect } from 'react-router-dom';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import SKUPatternList from './SKUPatternList';
import { formatProductTypes } from '../../sc-admin/SystemCertificate/utils';

const styles = (theme) => ({
    root: {
        width: `100%`,
        height: 'auto',
        paddingLeft: theme.spacing(-1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%',
        },
    },
});

const SKUPattern = (props) => {
    const { classes, columns, translations, permissions } = props;

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, skuPatternID: null, redirectPath: '' });
    const redirectHandler = (path, skuPatternID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, skuPatternID: skuPatternID, redirectPath: path });
    };

    let visible = columns && columns['SKUPattern'];
    const tableColumns = useMemo(() => {
        return [
            {
                title: translations['action'] || 'Action',
                field: 'Action',
                hidden: visible ? visible['Action'] : false,
                cellStyle: { minWidth: 100, maxWidth: 100 },
                filtering: false,
                render: (rowData) => (
                    <>
                        {hasPermission(permissions, 'sku_pattern_load') ? (
                            <Tooltip title={translations['sku_pattern_details'] || 'SKU pattern details'}>
                                <IconButton
                                    id={`edit_sku_pattern_${rowData.SKUPatternID}`}
                                    component="div"
                                    onClick={(event) =>
                                        redirectHandler(
                                            `/settings/sku-pattern/edit?skuPatternID=${rowData.SKUPatternID}`
                                        )
                                    }
                                >
                                    <FindInPage />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </>
                ),
            },
            {
                title: translations['name'] || 'Name',
                field: 'Name',
                hidden: visible ? visible['Name'] : false,
                filtering: true,
                render: (rowData) => {
                    return (
                        <Typography variant={'caption'}>
                            {rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}
                        </Typography>
                    );
                },
            },
            {
                title: translations['pattern'] || 'Pattern',
                field: 'Pattern',
                hidden: visible ? visible['Pattern'] : false,
                filtering: true,
                sorting: false,
                render: (rowData) => {
                    return (
                        <Typography variant={'caption'}>
                            {rowData.Pattern ? rowData.Pattern : translations['short_not_assigned'] || 'n/a'}
                        </Typography>
                    );
                },
            },
            {
                title: translations['product_type'] || 'Product type',
                field: 'ProductType',
                hidden: visible ? visible['ProductType'] : false,
                lookup: {
                    MobileProduct: translations['mobile_product'] || 'Mobile',
                    PCProduct: translations['pc_product'] || 'Workplace',
                    StorageProduct: translations['storage_product'] || 'Single disk-drives',
                },
                defaultFilter: ['MobileProduct', 'PCProduct', 'StorageProduct'],
                filtering: true,
                render: (rowData) => {
                    return (
                        <Typography variant={'caption'}>
                            {rowData.ProductType
                                ? formatProductTypes(rowData.ProductType, translations)
                                : translations['short_not_assigned'] || 'n/a'}
                        </Typography>
                    );
                },
            },
            {
                title: translations['system'] || 'System',
                field: 'System',
                hidden: visible ? visible['System'] : false,
                filtering: true,
                lookup: { 1: translations['system'] || 'System', 0: translations['custom'] || 'Custom' },
                defaultFilter: ['0', '1'],
                render: (rowData) => {
                    return (
                        <Typography variant={'caption'}>
                            {!rowData.CustomerID
                                ? translations['system'] || 'System'
                                : translations['custom'] || 'Custom'}
                        </Typography>
                    );
                },
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible]);
    if (!hasAtLeastOnePermission(permissions, ['sku_pattern_load'])) {
        tableColumns.shift();
    }
    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'sku_pattern_list') ? (
                <SKUPatternList tableColumns={tableColumns} redirectHandler={redirectHandler} />
            ) : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(mapStateToProps, null)(withStyles(styles)(SKUPattern));
